import React, { useEffect, useState } from "react";
import Header from "../Header";
import { supabase } from "../../../supabase";
import { Link } from "react-router-dom";

function Gallery() {
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGallery();
  }, []);

  const fetchGallery = async () => {
    try {
      const { data, error } = await supabase
        .from("gallery")
        .select("id, title, description, url")
        .order("created_at", { ascending: false });

      if (error) throw error;

      setGallery(data || []);
    } catch (err) {
      console.error("Error fetching gallery:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="main-content" id="mainContent">
      <Header heading="Gallery" />

      <div>
        <Link to="/admin-add-gallery" className="btn btn-dark mb-2">Add Image</Link>
        {loading ? (
          <p>Loading gallery...</p>
        ) : gallery.length === 0 ? (
          <p>No images found.</p>
        ) : (
          <div className="row">
            {gallery.map((item) => (
              <div className="col-lg-3 col-md-6 mb-4" key={item.id}>
                <div className="card h-100 shadow-sm">
                  <img
                    src={item.url}
                    alt={item.title}
                    className="card-img-top"
                    style={{
                      aspectRatio: "16/9",
                      objectFit: "cover",
                    }}
                  />

                  <div className="p-2">
                    <h5 className="mb-0" style={{ fontSize: "12px" }}>
                      {item.title}
                    </h5>
                    <p className="mt-2 mb-0" style={{ fontSize: "10px" }}>
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}

export default Gallery;
